'use client'

import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { useModalStore } from '@/stores/modal-store'
import { useTranslations } from 'next-intl'

function XIcon({ className }: { className?: string }) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" className={className}>
			<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
		</svg>
	)
}

export function SupportModal() {
	const { activeModal, closeModal } = useModalStore()
	const t = useTranslations('support')
	const isOpen = activeModal === 'support'

	return (
		<Dialog open={isOpen} onOpenChange={open => !open && closeModal()}>
			<DialogContent className="max-w-sm border-brand-gray bg-brand-dark-light">
				<DialogHeader>
					<DialogTitle className="text-center text-white text-xl">{t('title')}</DialogTitle>
					<DialogDescription className="text-center text-muted-foreground">
						{t('description')}
					</DialogDescription>
				</DialogHeader>
				<div className="mt-4">
					<a
						href="https://x.com/onautopilotfi"
						target="_blank"
						rel="noopener noreferrer"
						className="block w-full"
					>
						<Button className="w-full gap-2 bg-black hover:bg-black/80">
							<XIcon className="h-5 w-5" />
							{t('xButton')}
						</Button>
					</a>
				</div>
			</DialogContent>
		</Dialog>
	)
}
